import React, { useState } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';

import { useEspotData } from '~/store/Query/api';
import { CURRENCY_SYMBOL } from '~/store/States/global';

import '~/sass/modules/_planes-fijos-info.scss';

export default function InfoFijo({ fullname, priceText }) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const claroHogar = useEspotData('planes-claro-hogar');

  return (
    <div className="info-fijo">
      <div className="name-info">
        {fullname[0]}
        <Popover
          isOpen={isPopoverOpen}
          positions={['right', 'top']}
          onClickOutside={() => setIsPopoverOpen(false)}
          containerClassName="info-fijo--popover-container"
          content={({ position, childRect, popoverRect }) => (
            <ArrowContainer
              position={position}
              childRect={childRect}
              popoverRect={popoverRect}
              arrowColor="rgba(31, 29, 29, 0.75)"
              arrowSize={10}
              className="popover-arrow-container"
              arrowClassName="popover-arrow"
            >
              <div className="popover-content">
                <p
                  dangerouslySetInnerHTML={{
                    __html: claroHogar?.cart.popover.replace(/{PRECIO}/g, `${CURRENCY_SYMBOL}${priceText}`),
                  }}
                />
              </div>
            </ArrowContainer>
          )}
        >
          <span className="fa-stack info" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
            <i className="far fa-circle fa-stack-2x"></i>
            <i className="fas fa-info fa-stack-1x"></i>
          </span>
        </Popover>
      </div>
      {fullname.length > 1 && fullname.slice(1)}
    </div>
  );
}
